import { styled, Box, Container, Button, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { InvoicingHeaderModel } from '../../lib/models/InvoicingAndPayrollModel';
import theme from '../../theme';
import { useScreenLargerThan } from '../../lib/hooks/breakpoint-hooks';

export type InvoicingAndPayrollProps = {
    data: InvoicingHeaderModel;
};

const BoxSmallTitle = styled(Box)({
    color: theme.palette.primary.main,
    fontWeight: 700,
    fontSize: 16
});

const BoxSmallText = styled(Box)({
    display: 'inline-block',
    color: 'white',
    fontWeight: 400,
    fontSize: 16,
    paddingLeft: '0.5em'
});

const BoxMediumText = styled(Box)({
    display: 'inline-block',
    color: 'white',
    fontWeight: 400,
    fontSize: 18,
    paddingLeft: '0.938rem'
});

const InvoicingHeader = ({ data }: InvoicingAndPayrollProps) => {
    const isLargerThanMedium = useScreenLargerThan('md');

    return (
        <>
            <Box sx={{ backgroundColor: (t) => t.palette.secondary.light, paddingY: 2 }}>
                <Container maxWidth={'xl'}>
                    {isLargerThanMedium ? (
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: 6
                            }}>
                            <Stack direction={'row'} gap={5}>
                                <Box>
                                    <Box
                                        sx={{
                                            color: (t) => t.palette.primary.main,
                                            fontWeight: 700,
                                            fontSize: 20
                                        }}>
                                        Current Billing Cycle
                                        <BoxMediumText>{data.cycleInterval}</BoxMediumText>
                                    </Box>
                                </Box>

                                <Box
                                    sx={{
                                        color: (t) => t.palette.primary.main,
                                        fontWeight: 700,
                                        fontSize: 20
                                    }}>
                                    Cycle Total
                                    <BoxMediumText>{data.cycleTotal} Total Hours</BoxMediumText>
                                </Box>
                            </Stack>

                            <Box
                                sx={{
                                    display: 'inline-flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-end'
                                }}>
                                <Button
                                    component={Link}
                                    to={'/invoicing-payroll/past-cycles'}
                                    variant="outlined"
                                    sx={{
                                        paddingY: 1,
                                        border: 1
                                    }}>
                                    <Typography
                                        color={'primary'}
                                        fontWeight={(t) => t.typography.button.fontWeight}>
                                        View Past Cycles
                                    </Typography>
                                </Button>
                            </Box>
                        </Box>
                    ) : (
                        <Stack direction={'column'} gap={1}>
                            <Box>
                                <BoxSmallTitle>
                                    Current Billing Cycle
                                    <BoxSmallText>{data.cycleInterval}</BoxSmallText>
                                </BoxSmallTitle>
                            </Box>

                            <Box>
                                <BoxSmallTitle>
                                    Cycle Total
                                    <BoxSmallText>{data.cycleTotal} Total Hours</BoxSmallText>
                                </BoxSmallTitle>
                            </Box>

                            <Box
                                sx={{
                                    display: 'inline-flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-end',
                                    paddingY: '0.5em'
                                }}>
                                <Button
                                    component={Link}
                                    to={'/invoicing-payroll/past-cycles'}
                                    variant="outlined"
                                    sx={{
                                        paddingY: 1,
                                        border: 1
                                    }}>
                                    <Typography
                                        color={'primary'}
                                        fontWeight={(t) => t.typography.button.fontWeight}>
                                        View Past Cycles
                                    </Typography>
                                </Button>
                            </Box>
                        </Stack>
                    )}
                </Container>
            </Box>
        </>
    );
};

export default InvoicingHeader;
